import { useMemo } from 'react'
import useLocaleText from 'components/useLocaleText'
import { DEFAULT_T_RECORD_A_VIDEO, DEFAULT_T_TAKE_A_PHOTO } from '../TaskCreation/TaskCreationModal/Footer'

export const useTranslateDefaultTitle = (title?: string): string => {
  const t_take_a_photo = useLocaleText(DEFAULT_T_TAKE_A_PHOTO)
  const t_record_a_video = useLocaleText(DEFAULT_T_RECORD_A_VIDEO)

  const translationMap = useMemo<Record<string, string>>(
    () => ({
      [DEFAULT_T_TAKE_A_PHOTO]: t_take_a_photo,
      [DEFAULT_T_RECORD_A_VIDEO]: t_record_a_video,
    }),
    [t_take_a_photo, t_record_a_video]
  )

  return translationMap[title ?? ''] ?? title ?? ''
}
